(function () {
    'use strict';

    function convertToFloat() {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, element, attrs, ngModel) {
                ngModel.$parsers.push(function(val) {
                    return val != null ? parseFloat(val) : null;
                });
                ngModel.$formatters.push(function(val) {
                    return val != null ? '' + val : null;
                });
            }
        };
    }

    convertToFloat.$inject = [];

    angular.module('ecap.common').directive('convertToFloat', convertToFloat);
})();